import { useState, useEffect } from "react";
// ★U8(cmd-po_1109): sip-stepper共通部品
import { SipStepper } from "./common/SipStepper";

// ★cmd-po_1200(T2b-1): raw Modal frame → 共通外殻 PoModalShell
import { PoModalShell } from "./common/PoModalShell";

// ui
import {
  Button,
  Typography,
  Box,
  Paper,
  MenuItem,
} from "@mui/material";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";

// InterFace
import { LIST_POST, LIST } from "../config/const";

// API
import { getTossUpAddForm } from "../api/tossUp";
import { getAddress } from "../api/address";
import {
  getPresignedPostPicture,
  postPresignedPost,
} from "../api/presignedURL";

// jotai
import { useAtomValue } from "jotai";
import { AppAtoms } from "../lib/store";

// 共有部品
import { LeaveGuard } from "./list/LeaveGuard";
// ★ cmd-po_1135: po-form 共通部品
import { PoField, PoLabel, PoTextField, PoSelect, PoCheckbox, PoHelper, PoSplit, PoCheckGroup, PoCheckRow, PoFileDrop, PO_FORM_MSG, isValidMail, isValidTel, isValidZip } from "./common/PoForm";

interface InputFreeTextProps {
  addData: {
    addStatus:
      | null
      | "loading"
      | "change_account"
      | "product"
      | "toss_up"
      | "success"
      | "failed";
    category_id_list: number[];
    product_name_list: string[];
    phone_number: string;
    customer_name: string;
    customer_list_id: string;
    hope_call_date: string;
    hope_call_time_kind: number | null;
    hope_call_time: string;
    customerInfo: { [key: string]: string | string[] };
    changeAccount: 0 | 1;
    changeAccountID: number | null;
  };
  setAddData: React.Dispatch<
    React.SetStateAction<{
      addStatus:
        | null
        | "loading"
        | "change_account"
        | "product"
        | "toss_up"
        | "success"
        | "failed";
      category_id_list: number[];
      product_name_list: string[];
      phone_number: string;
      customer_name: string;
      customer_list_id: string;
      hope_call_date: string;
      hope_call_time_kind: number | null;
      hope_call_time: string;
      customerInfo: { [key: string]: string | string[] };
      changeAccount: 0 | 1;
      changeAccountID: number | null;
    }>
  >;
  uniqueOption: { [key: string]: string | number | string[] };
  addressOptionName: string;
}

function InputFreeText(props: InputFreeTextProps) {
  const { addData, setAddData, uniqueOption, addressOptionName } = props;
  return (
    <>
      <PoTextField
        disabled={uniqueOption.change_value_conf === 1}
        id="textFieldId"
        value={addData.customerInfo[uniqueOption.option_name as string]}
        onChange={async (e) => {
          let customerInfo = addData.customerInfo;
          customerInfo[uniqueOption.option_name as string] = e.target.value;
          setAddData((addData) => ({
            ...addData,
            customerInfo,
          }));
        }}
        fullWidth
        multiline={uniqueOption.multi_text_flg === 1}
        rows={uniqueOption.multi_text_flg === 1 ? 4 : undefined}
      />
      {uniqueOption.option_comment !== "" ? (
        <PoHelper>{uniqueOption.option_comment as string}</PoHelper>
      ) : null}
    </>
  );
}

function InputFreeTextHalfWidthNumber(props: InputFreeTextProps) {
  const { addData, setAddData, uniqueOption } = props;
  return (
    <>
      <PoTextField
        disabled={uniqueOption.change_value_conf === 1}
        id="textFieldId"
        value={addData.customerInfo[uniqueOption.option_name as string]}
        onChange={async (e) => {
          const inputValue = e.target.value;
          if (!/^\d*$/.test(inputValue)) return;
          let customerInfo = addData.customerInfo;
          customerInfo[uniqueOption.option_name as string] = inputValue;
          setAddData((addData) => ({
            ...addData,
            customerInfo,
          }));
        }}
        inputProps={{ inputMode: "numeric", pattern: "\\d*" }}
        fullWidth
      />
      {uniqueOption.option_comment !== "" ? (
        <PoHelper>{uniqueOption.option_comment as string}</PoHelper>
      ) : null}
    </>
  );
}

function InputFreeTextTel(props: InputFreeTextProps) {
  const { addData, setAddData, uniqueOption, addressOptionName } = props;
  const [input1, setInput1] = useState("");
  const [input2, setInput2] = useState("");
  const [input3, setInput3] = useState("");
  const [touched, setTouched] = useState(false);
  const invalid = touched && (input1 !== "" || input2 !== "" || input3 !== "") && !isValidTel(`${input1}-${input2}-${input3}`);
  useEffect(() => {
    if (
      input1 == "" &&
      input2 == "" &&
      input3 == "" &&
      addData.customerInfo[uniqueOption.option_name as string] &&
      addData.customerInfo[uniqueOption.option_name as string] != "" &&
      addData.customerInfo[uniqueOption.option_name as string].length !== 3
    ) {
      const option_value = addData.customerInfo[
        uniqueOption.option_name as string
      ] as string;
      const parts = option_value.split("-");
      setInput1(parts[0]);
      setInput2(parts[1]);
      setInput3(parts[2]);
    } else {
      let customerInfo = addData.customerInfo;
      customerInfo[uniqueOption.option_name as string] =
        input1 + "-" + input2 + "-" + input3;
      const phone_number = input1 + "-" + input2 + "-" + input3;
      setAddData((addData) => ({
        ...addData,
        phone_number,
        customerInfo,
      }));
    }
  }, [input1, input2, input3]);
  return (
    <>
      <PoSplit>
        <PoTextField
          id="textFieldIdTel1"
          value={input1}
          error={invalid}
          onBlur={() => setTouched(true)}
          onChange={async (e) => {
            const inputValue = e.target.value;
            if (/^\d*$/.test(inputValue)) {
              setInput1(inputValue);
            }
          }}
        />
        <Box sx={{ flex: "0 0 auto" }}>-</Box>
        <PoTextField
          id="textFieldIdTel2"
          value={input2}
          error={invalid}
          onBlur={() => setTouched(true)}
          onChange={async (e) => {
            const inputValue = e.target.value;
            if (/^\d*$/.test(inputValue)) {
              setInput2(inputValue);
            }
          }}
        />
        <Box sx={{ flex: "0 0 auto" }}>-</Box>
        <PoTextField
          id="textFieldIdTel3"
          value={input3}
          error={invalid}
          onBlur={() => setTouched(true)}
          onChange={async (e) => {
            const inputValue = e.target.value;
            if (/^\d*$/.test(inputValue)) {
              setInput3(inputValue);
            }
          }}
        />
      </PoSplit>
      {invalid ? (
        <PoHelper error>{PO_FORM_MSG.format}</PoHelper>
      ) : uniqueOption.option_comment !== "" ? (
        <PoHelper>{uniqueOption.option_comment as string}</PoHelper>
      ) : null}
    </>
  );
}

function InputFreeTextFormTel(props: InputFreeTextProps) {
  const { addData, setAddData, uniqueOption, addressOptionName } = props;
  const [input1, setInput1] = useState("");
  const [input2, setInput2] = useState("");
  const [input3, setInput3] = useState("");
  const [touched, setTouched] = useState(false);
  const invalid = touched && (input1 !== "" || input2 !== "" || input3 !== "") && !isValidTel(`${input1}-${input2}-${input3}`);
  useEffect(() => {
    if (
      input1 == "" &&
      input2 == "" &&
      input3 == "" &&
      addData.customerInfo[uniqueOption.option_name as string] &&
      addData.customerInfo[uniqueOption.option_name as string] != "" &&
      addData.customerInfo[uniqueOption.option_name as string].length !== 3
    ) {
      const option_value = addData.customerInfo[
        uniqueOption.option_name as string
      ] as string;
      const parts = option_value.split("-");
      setInput1(parts[0]);
      setInput2(parts[1]);
      setInput3(parts[2]);
    } else {
      let customerInfo = addData.customerInfo;
      customerInfo[uniqueOption.option_name as string] =
        input1 + "-" + input2 + "-" + input3;
      setAddData((addData) => ({
        ...addData,
        customerInfo,
      }));
    }
  }, [input1, input2, input3]);
  return (
    <>
      <PoSplit>
        <PoTextField
          id="textFieldIdTel1"
          value={input1}
          error={invalid}
          onBlur={() => setTouched(true)}
          onChange={async (e) => {
            const inputValue = e.target.value;
            if (/^\d*$/.test(inputValue)) {
              setInput1(inputValue);
            }
          }}
        />
        <Box sx={{ flex: "0 0 auto" }}>-</Box>
        <PoTextField
          id="textFieldIdTel2"
          value={input2}
          error={invalid}
          onBlur={() => setTouched(true)}
          onChange={async (e) => {
            const inputValue = e.target.value;
            if (/^\d*$/.test(inputValue)) {
              setInput2(inputValue);
            }
          }}
        />
        <Box sx={{ flex: "0 0 auto" }}>-</Box>
        <PoTextField
          id="textFieldIdTel3"
          value={input3}
          error={invalid}
          onBlur={() => setTouched(true)}
          onChange={async (e) => {
            const inputValue = e.target.value;
            if (/^\d*$/.test(inputValue)) {
              setInput3(inputValue);
            }
          }}
        />
      </PoSplit>
      {invalid ? (
        <PoHelper error>{PO_FORM_MSG.format}</PoHelper>
      ) : uniqueOption.option_comment !== "" ? (
        <PoHelper>{uniqueOption.option_comment as string}</PoHelper>
      ) : null}
    </>
  );
}

function InputFreeTextName(props: InputFreeTextProps) {
  const { addData, setAddData, uniqueOption, addressOptionName } = props;
  const [input1, setInput1] = useState("");
  const [input2, setInput2] = useState("");
  useEffect(() => {
    if (
      input1 == "" &&
      input2 == "" &&
      addData.customerInfo[uniqueOption.option_name as string] &&
      addData.customerInfo[uniqueOption.option_name as string] != "" &&
      addData.customerInfo[uniqueOption.option_name as string].length !== 2
    ) {
      const option_value = addData.customerInfo[
        uniqueOption.option_name as string
      ] as string;
      const parts = option_value.split(" ");
      setInput1(parts[0]);
      setInput2(parts[1]);
    } else {
      let customerInfo = addData.customerInfo;
      customerInfo[uniqueOption.option_name as string] = input1 + " " + input2;
      const customer_name = input1 + " " + input2;
      setAddData((addData) => ({
        ...addData,
        customer_name,
        customerInfo,
      }));
    }
  }, [input1, input2]);
  return (
    <>
      <PoSplit>
        <PoTextField
          id="textFieldIdName1"
          value={input1}
          onChange={async (e) => setInput1(e.target.value)}
        />
        <PoTextField
          id="textFieldIdName2"
          value={input2}
          onChange={async (e) => setInput2(e.target.value)}
        />
      </PoSplit>
      {uniqueOption.option_comment !== "" ? (
        <PoHelper>{uniqueOption.option_comment as string}</PoHelper>
      ) : null}
    </>
  );
}

function InputFreeTextZipCode(props: InputFreeTextProps) {
  const { addData, setAddData, uniqueOption, addressOptionName } = props;
  const [input1, setInput1] = useState("");
  const [input2, setInput2] = useState("");
  const [touched, setTouched] = useState(false);
  const invalid = touched && (input1 !== "" || input2 !== "") && !isValidZip(`${input1}-${input2}`);
  useEffect(() => {
    async function getAddressText(zipCode: string) {
      let customerInfo = addData.customerInfo;
      customerInfo[uniqueOption.option_name as string] = zipCode;
      setAddData((addData) => ({
        ...addData,
        customerInfo,
      }));

      const address = await getAddress(zipCode);
      customerInfo[addressOptionName] = address;
      setAddData((addData) => ({
        ...addData,
        customerInfo,
      }));
    }
    if (
      input1 == "" &&
      input2 == "" &&
      addData.customerInfo[uniqueOption.option_name as string] &&
      addData.customerInfo[uniqueOption.option_name as string] != "" &&
      addData.customerInfo[uniqueOption.option_name as string].length !== 2
    ) {
      const option_value = addData.customerInfo[
        uniqueOption.option_name as string
      ] as string;
      const parts = option_value.split("-");
      setInput1(parts[0]);
      setInput2(parts[1]);
    } else {
      const zipCode = input1 + "-" + input2;
      if (input1.length === 3 && input2.length === 4) {
        getAddressText(zipCode);
      } else {
        let customerInfo = addData.customerInfo;
        customerInfo[uniqueOption.option_name as string] = zipCode;
        setAddData((addData) => ({
          ...addData,
          customerInfo,
        }));
      }
    }
  }, [input1, input2]);
  return (
    <>
      <PoSplit>
        <PoTextField
          id="textFieldIdZipCode1"
          value={input1}
          inputProps={{ maxLength: 3 }}
          error={invalid}
          onBlur={() => setTouched(true)}
          onChange={async (e) => {
            const inputValue = e.target.value;
            if (/^\d*$/.test(inputValue) && inputValue.length <= 3) {
              setInput1(inputValue);
            }
          }}
        />
        <Box sx={{ flex: "0 0 auto" }}>-</Box>
        <PoTextField
          id="textFieldIdZipCode2"
          value={input2}
          inputProps={{ maxLength: 4 }}
          error={invalid}
          onBlur={() => setTouched(true)}
          onChange={async (e) => {
            const inputValue = e.target.value;
            if (/^\d*$/.test(inputValue) && inputValue.length <= 4) {
              setInput2(inputValue);
            }
          }}
        />
      </PoSplit>
      {invalid ? (
        <PoHelper error>{PO_FORM_MSG.format}</PoHelper>
      ) : uniqueOption.option_comment !== "" ? (
        <PoHelper>{uniqueOption.option_comment as string}</PoHelper>
      ) : null}
    </>
  );
}

function InputFreeTextSpace(props: InputFreeTextProps) {
  const { addData, setAddData, uniqueOption, addressOptionName } = props;
  const [input1, setInput1] = useState("");
  const [input2, setInput2] = useState("");
  useEffect(() => {
    if (
      input1 == "" &&
      input2 == "" &&
      addData.customerInfo[uniqueOption.option_name as string] &&
      addData.customerInfo[uniqueOption.option_name as string] != "" &&
      addData.customerInfo[uniqueOption.option_name as string].length !== 2
    ) {
      const option_value = addData.customerInfo[
        uniqueOption.option_name as string
      ] as string;
      const parts = option_value.split(" ");
      setInput1(parts[0]);
      setInput2(parts[1]);
    } else {
      let customerInfo = addData.customerInfo;
      customerInfo[uniqueOption.option_name as string] = input1 + " " + input2;
      setAddData((addData) => ({
        ...addData,
        customerInfo,
      }));
    }
  }, [input1, input2]);
  return (
    <>
      <PoSplit>
        <PoTextField
          id="textFieldIdSpace1"
          value={input1}
          onChange={async (e) => setInput1(e.target.value)}
        />
        <PoTextField
          id="textFieldIdSpace2"
          value={input2}
          onChange={async (e) => setInput2(e.target.value)}
        />
      </PoSplit>
      {uniqueOption.option_comment !== "" ? (
        <PoHelper>{uniqueOption.option_comment as string}</PoHelper>
      ) : null}
    </>
  );
}

function InputFreeTextMailAddress(props: InputFreeTextProps) {
  const { addData, setAddData, uniqueOption, addressOptionName } = props;
  const [input1, setInput1] = useState("");
  const [input2, setInput2] = useState("");
  const [touched, setTouched] = useState(false);
  const invalid = touched && (input1 !== "" || input2 !== "") && !isValidMail(`${input1}@${input2}`);
  useEffect(() => {
    if (
      input1 == "" &&
      input2 == "" &&
      addData.customerInfo[uniqueOption.option_name as string] &&
      addData.customerInfo[uniqueOption.option_name as string] != "" &&
      addData.customerInfo[uniqueOption.option_name as string].length !== 2
    ) {
      const option_value = addData.customerInfo[
        uniqueOption.option_name as string
      ] as string;
      const parts = option_value.split("@");
      setInput1(parts[0]);
      setInput2(parts[1]);
    } else {
      let customerInfo = addData.customerInfo;
      customerInfo[uniqueOption.option_name as string] = input1 + "@" + input2;
      setAddData((addData) => ({
        ...addData,
        customerInfo,
      }));
    }
  }, [input1, input2]);
  return (
    <>
      <PoSplit>
        <PoTextField
          id="textFieldIdmm1"
          value={input1}
          error={invalid}
          onBlur={() => setTouched(true)}
          onChange={async (e) => setInput1(e.target.value)}
        />
        <Box sx={{ flex: "0 0 auto" }}>@</Box>
        <PoTextField
          id="textFieldIdmm2"
          value={input2}
          error={invalid}
          onBlur={() => setTouched(true)}
          onChange={async (e) => setInput2(e.target.value)}
        />
      </PoSplit>
      {invalid ? (
        <PoHelper error>{PO_FORM_MSG.format}</PoHelper>
      ) : uniqueOption.option_comment !== "" ? (
        <PoHelper>{uniqueOption.option_comment as string}</PoHelper>
      ) : null}
    </>
  );
}

interface TossUpAddModalProps {
  onModal: boolean;
  swCloseModal: () => void;
  postAddData: (customerInfo: { [key: string]: string | string[] }) => void;
  addData: {
    addStatus:
      | null
      | "loading"
      | "change_account"
      | "product"
      | "toss_up"
      | "success"
      | "failed";
    category_id_list: number[];
    product_name_list: string[];
    phone_number: string;
    customer_name: string;
    customer_list_id: string;
    hope_call_date: string;
    hope_call_time_kind: number | null;
    hope_call_time: string;
    customerInfo: { [key: string]: string | string[] };
    changeAccount: 0 | 1;
    changeAccountID: number | null;
  };
  setAddData: React.Dispatch<
    React.SetStateAction<{
      addStatus:
        | null
        | "loading"
        | "change_account"
        | "product"
        | "toss_up"
        | "success"
        | "failed";
      category_id_list: number[];
      product_name_list: string[];
      phone_number: string;
      customer_name: string;
      customer_list_id: string;
      hope_call_date: string;
      hope_call_time_kind: number | null;
      hope_call_time: string;
      customerInfo: { [key: string]: string | string[] };
      changeAccount: 0 | 1;
      changeAccountID: number | null;
    }>
  >;
  uniqueOptinList: { [key: string]: string | number | string[] }[];
  setUniqueOptinList: (
    value: { [key: string]: string | number | string[] }[],
  ) => void;
  addressOptionName: string;
  setAddressOptionName: (name: string) => void;
  postPictures: {
    [key: string]: File;
  };
  setPostPicture: (value: { [key: string]: File }) => void;
  tossUpCategoryNameList: {
    category_id: number;
    category_name: string;
  }[];
  tossUpProductNameList: {
    category_id: number;
    category_name: string;
    product_name: string;
  }[];
  setOnDataAddModalResult: (value: string) => void;
  accountCollaborateCompanySaleList?: {
    sale_company_id: number;
    sale_company_name: string;
    id: number;
    account_name: string;
  }[];
  accountColumn?: string;
  getFormFunction?: () => void;
}

export function TossUpAddModal(props: TossUpAddModalProps) {
  const {
    onModal,
    swCloseModal,
    postAddData,
    addData,
    setAddData,
    uniqueOptinList,
    setUniqueOptinList,
    addressOptionName,
    setAddressOptionName,
    postPictures,
    setPostPicture,
    tossUpCategoryNameList,
    tossUpProductNameList,
    setOnDataAddModalResult,
    accountCollaborateCompanySaleList,
    accountColumn,
    getFormFunction,
  } = props;
  const isSmartPhone = useAtomValue(AppAtoms.isSmartPhone);
  const loginUser = useAtomValue(AppAtoms.loginUser);
  const [leaveGuardOpen, setLeaveGuardOpen] = useState(false);
  const [postPicturesError, setPostPicturesError] = useState<{[key: string]: string}>({});

  const hasStep1 = getFormFunction !== undefined;

  const acctName = (() => {
    if (addData.changeAccount === 1 && addData.changeAccountID !== null) {
      return (accountCollaborateCompanySaleList ?? []).find(
        (x) => x.id === addData.changeAccountID
      )?.account_name ?? "";
    }
    return loginUser?.username ?? "";
  })();

  // ★cmd-po_1200: frame sx(旧 const style=fixed/680px/92vh/radius/shadow)は PoModalShell width="w680"(PO_MODAL_SX_W680)へ移譲。
  //   PC幅680px・maxHeight92vh・radius/shadow(var同一)は保全。position fixed→absolute・zIndex310除去は共通外殻へ吸収(PC視覚不変)。

  async function getFormInfo() {
    setAddData((addData) => ({
      ...addData,
      addStatus: "loading",
    }));
    const { option_data } = await getTossUpAddForm(
      addData.category_id_list,
      addData.product_name_list,
      addData.changeAccount,
      addData.changeAccountID,
    );
    setUniqueOptinList(option_data);
    if (option_data.length > 0) {
      const customerInfo: {
        [key: string]: string | string[];
      } = option_data.reduce<{ [key: string]: string | string[] }>(
        (column, option) => {
          let option_value: string | string[] = "";
          if (option.option_type === 0) {
            option_value = option.option_default_value as string;
            return {
              ...column,
              [option.option_name as string]: option_value,
            };
          } else if (option.option_type === 1 || option.option_type === 4) {
            return {
              ...column,
              [option.option_name as string]: "",
            };
          } else if (option.option_type === 3) {
            return {
              ...column,
              [option.option_name as string]: "",
            };
          } else {
            return {
              ...column,
              [option.option_name as string]: [],
            };
          }
        },
        {},
      );
      let addressOptionName = "";
      option_data.map((uniqueOptin) => {
        if (uniqueOptin.address_flg) {
          addressOptionName = uniqueOptin.option_name as string;
        }
      });
      setAddressOptionName(addressOptionName);
      setAddData((addData) => ({
        ...addData,
        customerInfo,
        addStatus: "toss_up",
      }));
    } else {
      swCloseModal();
      setOnDataAddModalResult(
        "トスアップフォームが定義されていません。管理者に問い合わせてください。",
      );
    }
  }

  const [onPostBottun, setOnPostBottun] = useState(false);
  useEffect(() => {
    if (addData.addStatus !== null && addData.addStatus !== "loading") {
      let onPostBottun = true;
      if (addData.hope_call_date === "") {
        onPostBottun = false;
      }
      if (addData.hope_call_time_kind === null) {
        onPostBottun = false;
      }
      if (addData.hope_call_time_kind === 1 && addData.hope_call_time === "") {
        onPostBottun = false;
      }
      uniqueOptinList.map((uniqueOptin) => {
        const product_names = uniqueOptin.product_names as string[];
        const depend_option_name = uniqueOptin.depend_option_name as string;
        const depend_select_names = uniqueOptin.depend_select_names as string[];
        const depend_option_value = addData.customerInfo[depend_option_name];
        if (
          uniqueOptin.required_optional === 1 &&
          (product_names.length === 0 ||
            product_names.some((item) =>
              addData.product_name_list.includes(item),
            )) &&
          (depend_option_name === "他質問に依存しない" ||
            (typeof depend_option_value === "string" &&
              depend_select_names.includes(depend_option_value as string)) ||
            (typeof depend_option_value === "object" &&
              depend_select_names.some((item) =>
                depend_option_value.includes(item),
              )))
        ) {
          if (
            uniqueOptin.option_type === 0 ||
            uniqueOptin.option_type === 1 ||
            uniqueOptin.option_type === 3
          ) {
            const customerInfoValue = addData.customerInfo[
              uniqueOptin.option_name as string
            ] as string;
            if (
              customerInfoValue === undefined ||
              customerInfoValue === "" ||
              customerInfoValue === " " ||
              customerInfoValue === "--"
            ) {
              onPostBottun = false;
            }
          } else if (uniqueOptin.option_type === 2) {
            const customerInfoValue = addData.customerInfo[
              uniqueOptin.option_name as string
            ] as string[];
            if (customerInfoValue.length === 0) {
              onPostBottun = false;
            }
          } else if (uniqueOptin.option_type === 4) {
            if (!postPictures[uniqueOptin.option_name as string]) {
              onPostBottun = false;
            }
          }
        }
      });
      setOnPostBottun(onPostBottun);
    }
  }, [addData, postPictures]);

  // 契約登録前に画像データ格納
  async function postAddTossUpData() {
    setAddData((addData) => ({
      ...addData,
      addStatus: "loading",
    }));
    let customerInfo = { ...addData.customerInfo };
    const results = await Promise.all(
      uniqueOptinList.map(async (uniqueOption) => {
        if (
          uniqueOption.option_type === 4 &&
          postPictures[uniqueOption.option_name as string]
        ) {
          const postPicture = postPictures[uniqueOption.option_name as string];
          // 著名付きURL(post用)を作成
          const fileName = postPicture.name;
          const date = new Date();
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, "0"); // 月は0始まりのため+1
          const day = String(date.getDate()).padStart(2, "0");
          const hours = String(date.getHours()).padStart(2, "0");
          const minutes = String(date.getMinutes()).padStart(2, "0");
          const seconds = String(date.getSeconds()).padStart(2, "0");
          const nowTimeName = `${year}${month}${day}${hours}${minutes}${seconds}`;
          const { presigned_object, destination_key } =
            await getPresignedPostPicture(nowTimeName, fileName);

          // POSTする form に持たせるデータを生成する
          const formData = new FormData();
          for (const key in presigned_object.fields) {
            formData.append(key, presigned_object.fields[key]);
          }
          formData.append("file", postPicture);
          // ファイルをS3にアップロード（S3受理確認）
          const r = await postPresignedPost(presigned_object.url, formData);
          if (r === "seccess") {
            customerInfo[uniqueOption.option_name as string] = destination_key;
          }
          return r;
        }
        return "seccess";
      }),
    );
    if (results.some((r) => r !== "seccess")) {
      const errMap: {[key: string]: string} = {};
      uniqueOptinList.forEach((opt, i) => {
        if (results[i] !== "seccess") {
          errMap[opt.option_name as string] = "画像のアップロードに失敗しました。もう一度お試しください。";
        }
      });
      setPostPicturesError(errMap);
      setAddData((addData) => ({ ...addData, addStatus: "toss_up" }));
      setOnDataAddModalResult("画像のアップロードに失敗しました。もう一度お試しください");
      return;
    }
    await postAddData(customerInfo);
  }

  // ★cmd-po_1200(T2b-1): footer は addStatus 別に raw Button を verbatim（PoButton化せず po-btn 機能class維持）で PoModalShell footer prop へ移設。
  //   旧「modal Box直下 pin」2分岐（product/toss_up）を集約。change_account=footer無(undefined)。
  const tossUpAddFooter =
    addData.addStatus === "product" ? (
      <>
        <Button
          data-testid="tossup-add-product-back-button"
          variant="outlined"
          className="po-btn po-btn-secondary"
          sx={{
            textTransform: "none",
            minWidth: "unset",
            boxShadow: "none",
            backgroundColor: "var(--color-white, #ffffff)",
            color: "var(--color-ai, #1e3a5f)",
            border: "1px solid var(--color-border, #e5e5e0)",
            padding: "0 var(--sp-4, 16px)",
            height: isSmartPhone ? "var(--control-h-sp, 44px)" : "var(--control-h, 36px)",
            "&:hover": { boxShadow: "none", backgroundColor: "var(--color-white, #ffffff)" },
          }}
          onClick={() => {
            if (hasStep1) {
              setLeaveGuardOpen(true);
            } else {
              swCloseModal();
            }
          }}
        >
          <Box>戻る</Box>
        </Button>
        <Button
          data-testid="tossup-add-product-next-button"
          disabled={addData.category_id_list.length === 0}
          variant="contained"
          className="po-btn po-btn-primary"
          sx={{
            textTransform: "none",
            minWidth: "unset",
            boxShadow: "none",
            backgroundColor: "var(--color-ai, #1e3a5f)",
            color: "var(--color-white, #ffffff)",
            border: "1px solid transparent",
            padding: "0 var(--sp-4, 16px)",
            height: isSmartPhone ? "var(--control-h-sp, 44px)" : "var(--control-h, 36px)",
            "&:hover": { boxShadow: "none", backgroundColor: "var(--color-ai-light, #2a5a8f)" },
            "&.Mui-disabled": { bgcolor: "var(--state-disabled-bg, #f0f0ec)", color: "var(--state-disabled-fg, #9ca3af)", cursor: "not-allowed", pointerEvents: "auto" },
          }}
          onClick={async () => {
            await getFormInfo();
          }}
        >
          <Box >次へ</Box>
        </Button>
      </>
    ) : addData.addStatus === "toss_up" ? (
      <>
        <Button
          data-testid="tossup-add-final-back-button"
          variant="outlined"
          className="po-btn po-btn-secondary"
          sx={{
            textTransform: "none",
            minWidth: "unset",
            boxShadow: "none",
            backgroundColor: "var(--color-white, #ffffff)",
            color: "var(--color-ai, #1e3a5f)",
            border: "1px solid var(--color-border, #e5e5e0)",
            padding: "0 var(--sp-4, 16px)",
            height: isSmartPhone ? "var(--control-h-sp, 44px)" : "var(--control-h, 36px)",
            "&:hover": { boxShadow: "none", backgroundColor: "var(--color-white, #ffffff)" },
          }}
          onClick={() => {
            setAddData((addData) => ({
              ...addData,
              addStatus: "product",
              category_id_list: [],
              product_name_list: [],
              customerInfo: {},
            }));
            setUniqueOptinList([]);
            setAddressOptionName("");
          }}
        >
          <Box>戻る</Box>
        </Button>
        <Button
          data-testid="tossup-add-submit-button"
          disabled={!onPostBottun}
          variant="contained"
          className="po-btn po-btn-primary"
          sx={{
            textTransform: "none",
            minWidth: "unset",
            boxShadow: "none",
            backgroundColor: "var(--color-ai, #1e3a5f)",
            color: "var(--color-white, #ffffff)",
            border: "1px solid transparent",
            padding: "0 var(--sp-4, 16px)",
            height: isSmartPhone ? "var(--control-h-sp, 44px)" : "var(--control-h, 36px)",
            "&:hover": { boxShadow: "none", backgroundColor: "var(--color-ai-light, #2a5a8f)" },
            "&.Mui-disabled": { bgcolor: "var(--state-disabled-bg, #f0f0ec)", color: "var(--state-disabled-fg, #9ca3af)", cursor: "not-allowed", pointerEvents: "auto" },
          }}
          onClick={postAddTossUpData}
        >
          <Box
            style={{
              color: !onPostBottun ? "rgb(70 70 70)" : undefined,
            }}
          >
            新規登録
          </Box>
          <AddCircleOutlineIcon
            sx={{
              marginLeft: "6px",
              color: !onPostBottun ? "rgb(70 70 70)" : "white",
            }}
            fontSize="medium"
          />
        </Button>
      </>
    ) : undefined;

  return addData.addStatus !== null && addData.addStatus !== "loading" ? (
    // cmd-po_1200(T2b-1): raw Modal → 共通外殻 PoModalShell（precedent=ProductEditModal:1163 / cmd-1199）
    // ★SipStepper=beforeBody slot(header直後・非スクロール帯=視覚位置保全) / footer=addStatus別 raw Button verbatim(po-btn機能class維持) / LeaveGuard=PoModalShell兄弟
    // ★backdrop/Escで閉じない現挙動保全（旧Modalに onClose 無配線=PoModalShell も同=差異なし）
    <>
      <PoModalShell
        open={onModal}
        title="トスアップ登録"
        onClose={swCloseModal}
        width="w680"
        testidPrefix="tossup-add"
        beforeBody={
          <SipStepper
            steps={hasStep1 ? ["担当アカウント", "商材選択", "情報入力"] : ["商材選択", "情報入力"]}
            activeIndex={
              hasStep1
                ? addData.addStatus === "change_account" ? 0
                  : addData.addStatus === "product" ? 1
                  : 2
                : addData.addStatus === "product" ? 0 : 1
            }
            suffix={
              hasStep1 && addData.addStatus !== "change_account" && acctName ? (
                <Box sx={{ fontSize: 11, fontWeight: 600, color: "var(--color-ai, #1e3a5f)", bgcolor: "var(--color-ai-pale, #e8eef4)", borderRadius: "999px", px: 1.25, py: 0.375, flexShrink: 0, whiteSpace: "nowrap" }}>
                  担当: {acctName}
                </Box>
              ) : undefined
            }
          />
        }
        footer={tossUpAddFooter}
      >
        {addData.addStatus === "product" ? (
          <Typography
            id="modal-modal-description"
            sx={{
              mt: 0,
              mb: 5,
              maxHeight: !isSmartPhone ? undefined : "calc(92vh - 50px)",
              overflowY: !isSmartPhone ? undefined : "auto",
            }}
            key="TossUpAddModalBoxProject"
          >
            <Paper elevation={0} data-testid="tossup-add-product-list" sx={{ display: "flex", flexDirection: "column", gap: "var(--sp-4, 16px)" }}>
              <Box sx={{ px: 2.5, pt: 2, pb: 0.5, fontSize: 13, color: "var(--color-text, #374151)" }}>
                トスアップする商材を選択してください（カテゴリー選択で配下の商材を一括選択）
              </Box>
              <Box
                key="shozai1"
                sx={{}}
              >
                <Box key="shozaiClick">
                  {tossUpCategoryNameList.map((categoryName, category_i) => {
                    function categoryDisabled(category_id: number) {
                      let categoryDisabled = false;
                      tossUpProductNameList.map((productName) => {
                        if (
                          addData.product_name_list.includes(
                            productName.product_name,
                          ) &&
                          category_id === productName.category_id
                        ) {
                          categoryDisabled = true;
                        }
                      });
                      return categoryDisabled;
                    }
                    return (
                      <Box
                        key={"category_name_" + category_i}
                        data-testid="tossup-add-product-cat"
                        sx={{ border: "1px solid var(--color-border-light, #efefea)", borderRadius: "var(--radius-sm, 6px)", overflow: "hidden" }}
                      >
                        <Box
                          data-testid={category_i === 0 ? "tossup-add-product-category-0" : undefined}
                          sx={{ display: "flex", alignItems: "center", gap: "var(--sp-2, 8px)", padding: "var(--sp-3, 12px)", bgcolor: "var(--color-washi, #f8f7f2)", fontSize: "var(--fs-13, 13px)", fontWeight: "var(--fw-bold, 700)", color: "var(--color-sumi, #374151)" }}
                        >
                          <PoCheckbox
                            checked={addData.category_id_list.includes(
                              categoryName.category_id,
                            )}
                            disabled={
                              categoryDisabled(categoryName.category_id)
                                ? true
                                : false
                            }
                            onClick={() => {
                              let _category_id_list =
                                addData.category_id_list.concat();
                              let _product_name_list =
                                addData.product_name_list.concat();
                              if (
                                addData.category_id_list.includes(
                                  categoryName.category_id,
                                )
                              ) {
                                _category_id_list = _category_id_list.filter(
                                  (category_id) =>
                                    category_id !== categoryName.category_id,
                                );
                              } else {
                                _category_id_list.push(
                                  categoryName.category_id,
                                );
                                tossUpProductNameList.map((tossUpProduct) => {
                                  if (
                                    tossUpProduct.category_id ===
                                    categoryName.category_id
                                  ) {
                                    _product_name_list.push(
                                      tossUpProduct.product_name,
                                    );
                                  }
                                });
                              }
                              setAddData((addData) => ({
                                ...addData,
                                category_id_list: _category_id_list,
                                product_name_list: _product_name_list,
                              }));
                            }}
                            sx={{ marginTop: "-2px" }}
                          />
                          {categoryName.category_name}
                        </Box>
                        {tossUpProductNameList.map((productName, product_i) => {
                          if (
                            categoryName.category_name ===
                            productName.category_name
                          ) {
                            return (
                              <Box
                                key={
                                  "category_product_name_" +
                                  category_i +
                                  "_" +
                                  product_i
                                }
                                data-testid="tossup-add-product-item"
                                sx={{ display: "flex", alignItems: "center", gap: "var(--sp-2, 8px)", padding: "var(--sp-3, 12px) var(--sp-3, 12px) var(--sp-3, 12px) var(--sp-6, 24px)", fontSize: "var(--fs-13, 13px)", color: "var(--color-sumi, #374151)", borderTop: "1px solid var(--color-border-light, #efefea)" }}
                              >
                                <PoCheckbox
                                  checked={addData.product_name_list.includes(
                                    productName.product_name,
                                  )}
                                  onClick={() => {
                                    let _category_id_list =
                                      addData.category_id_list.concat();
                                    let _product_name_list =
                                      addData.product_name_list.concat();
                                    if (
                                      addData.product_name_list.includes(
                                        productName.product_name,
                                      )
                                    ) {
                                      _product_name_list =
                                        _product_name_list.filter(
                                          (product_name) =>
                                            product_name !==
                                            productName.product_name,
                                        );
                                    } else {
                                      _product_name_list.push(
                                        productName.product_name,
                                      );
                                      if (
                                        !addData.category_id_list.includes(
                                          categoryName.category_id,
                                        )
                                      ) {
                                        _category_id_list.push(
                                          categoryName.category_id,
                                        );
                                      }
                                    }
                                    setAddData((addData) => ({
                                      ...addData,
                                      category_id_list: _category_id_list,
                                      product_name_list: _product_name_list,
                                    }));
                                  }}
                                  sx={{ marginTop: "-2px", marginLeft: "20px" }}
                                />
                                {productName.product_name}
                              </Box>
                            );
                          }
                        })}
                      </Box>
                    );
                  })}
                </Box>
              </Box>
            </Paper>
          </Typography>
        ) : addData.addStatus === "toss_up" ? (
          <Typography
            key="TossUpAddModalBoxContract"
            id="modal-modal-description"
            sx={{
              mt: 2,
              mb: 5,
              maxHeight: !isSmartPhone ? undefined : "calc(92vh - 30px)",
              overflowY: !isSmartPhone ? undefined : "auto",
            }}
          >
            <Paper elevation={0}>
              {addData.product_name_list.length > 0 && (
                <Box sx={{ px: 2.5, pt: 1.5, pb: 1 }}>
                  <Box sx={{ fontSize: 11, color: "var(--color-text, #374151)", mb: 0.5 }}>選択中の商材</Box>
                  {addData.product_name_list.map((name, i) => (
                    <Box key={i} sx={{ fontSize: 13, fontWeight: 600, color: "var(--color-ai, #1e3a5f)" }}>{name}</Box>
                  ))}
                </Box>
              )}
              <Box
                key="contract1"
                sx={{ display: "flex", flexDirection: "column", gap: "var(--sp-4, 16px)" }}
              >
                <PoField fieldKey="customer_list_id">
                  <PoLabel optional>リストID</PoLabel>
                  <PoTextField
                    id="textFieldIdListID"
                    fullWidth
                    value={addData.customer_list_id}
                    onChange={async (e) => {
                      setAddData((addData) => ({
                        ...addData,
                        customer_list_id: e.target.value,
                      }));
                    }}
                  />
                </PoField>
                <PoField fieldKey="hope_call_date">
                  <PoLabel required>架電希望日</PoLabel>
                  <PoTextField
                    id="hope_call_date"
                    fullWidth
                    type="date"
                    value={addData.hope_call_date}
                    onChange={async (e) => {
                      setAddData((addData) => ({
                        ...addData,
                        hope_call_date: e.target.value,
                      }));
                    }}
                  />
                </PoField>
                <PoField fieldKey="hope_call_time_kind">
                  <PoLabel required>架電希望タイミング</PoLabel>
                  <PoSelect
                    labelId="serch-input-label"
                    id="serch-input-option"
                    key={"tableColumnKomokuDataSelectTiming"}
                    value={addData.hope_call_time_kind}
                    onChange={(e) => {
                      setAddData((addData) => ({
                        ...addData,
                        hope_call_time_kind: e.target.value as number,
                      }));
                    }}
                    fullWidth
                  >
                    {LIST_POST.hope_call_time_kind.map((input, i) => {
                      return (
                        <MenuItem
                          key={"tableColumnKomokuDataSelectTiming" + i}
                          value={input.id}
                          sx={{
                            fontSize: "14px",
                            height: input.value === "" ? "14px" : "24px",
                            minHeight: "auto",
                          }}
                        >
                          {input.value}
                        </MenuItem>
                      );
                    })}
                  </PoSelect>
                </PoField>
                {addData.hope_call_time_kind === 1 ? (
                  <PoField fieldKey="hope_call_time">
                    <PoLabel note="※時間指定">架電希望時間</PoLabel>
                    <PoSplit>
                      <PoSelect
                        value={addData.hope_call_time.split("-")[0]}
                        onChange={(e) => {
                          setAddData((addData) => ({
                            ...addData,
                            hope_call_time:
                              (e.target.value as string) +
                              "-" +
                              addData.hope_call_time.split("-")[1],
                          }));
                        }}
                      >
                        {LIST.hope_call_time_hour.map((time, i) => (
                          <MenuItem
                            key={"tableColumnKomokuDataSelectTiming" + i}
                            value={time}
                            sx={{
                              fontSize: "14px",
                              height: time === "" ? "14px" : "24px",
                              minHeight: "auto",
                            }}
                          >
                            {time}
                          </MenuItem>
                        ))}
                      </PoSelect>
                      <PoSelect
                        value={addData.hope_call_time.split("-")[1]}
                        onChange={(e) => {
                          setAddData((addData) => ({
                            ...addData,
                            hope_call_time:
                              addData.hope_call_time.split("-")[0] +
                              "-" +
                              (e.target.value as string),
                          }));
                        }}
                      >
                        {LIST.hope_call_time_minute.map((time, i) => (
                          <MenuItem
                            key={"tableColumnKomokuDataSelectTiming" + i}
                            value={time}
                            sx={{
                              fontSize: "14px",
                              height: time === "" ? "14px" : "24px",
                              minHeight: "auto",
                            }}
                          >
                            {time}
                          </MenuItem>
                        ))}
                      </PoSelect>
                    </PoSplit>
                  </PoField>
                ) : null}
                {uniqueOptinList.map((uniqueOption, option_i) => {
                  const option_selects = uniqueOption.option_select as string[];
                  const product_names = uniqueOption.product_names as string[];
                  const depend_option_name =
                    uniqueOption.depend_option_name as string;
                  const depend_select_names =
                    uniqueOption.depend_select_names as string[];
                  const depend_option_value =
                    addData.customerInfo[depend_option_name];
                  if (
                    (product_names.length === 0 ||
                      product_names.some((item) =>
                        addData.product_name_list.includes(item),
                      )) &&
                    (depend_option_name === "他質問に依存しない" ||
                      (typeof depend_option_value === "string" &&
                        depend_select_names.includes(
                          depend_option_value as string,
                        )) ||
                      (typeof depend_option_value === "object" &&
                        depend_select_names.some((item) =>
                          depend_option_value.includes(item),
                        )))
                  ) {
                    return (
                      <PoField key={"optionBox_" + option_i} fieldKey={uniqueOption.option_name as string}>
                        <PoLabel
                          required={uniqueOption.required_optional === 1}
                          optional={uniqueOption.required_optional !== 1}
                        >
                          {uniqueOption.option_name}
                        </PoLabel>
                        {uniqueOption.option_type === 0 ? (
                          uniqueOption.tel_flg === 1 ? (
                            <InputFreeTextTel
                              addData={addData}
                              setAddData={setAddData}
                              uniqueOption={uniqueOption}
                              addressOptionName={addressOptionName}
                            />
                          ) : uniqueOption.name_flg === 1 ? (
                            <InputFreeTextName
                              addData={addData}
                              setAddData={setAddData}
                              uniqueOption={uniqueOption}
                              addressOptionName={addressOptionName}
                            />
                          ) : uniqueOption.zip_code_flg === 1 ? (
                            <InputFreeTextZipCode
                              addData={addData}
                              setAddData={setAddData}
                              uniqueOption={uniqueOption}
                              addressOptionName={addressOptionName}
                            />
                          ) : uniqueOption.space_flg === 1 ? (
                            <InputFreeTextSpace
                              addData={addData}
                              setAddData={setAddData}
                              uniqueOption={uniqueOption}
                              addressOptionName={addressOptionName}
                            />
                          ) : uniqueOption.mail_address_flg === 1 ? (
                            <InputFreeTextMailAddress
                              addData={addData}
                              setAddData={setAddData}
                              uniqueOption={uniqueOption}
                              addressOptionName={addressOptionName}
                            />
                          ) : uniqueOption.form_tel_flg === 1 ? (
                            <InputFreeTextFormTel
                              addData={addData}
                              setAddData={setAddData}
                              uniqueOption={uniqueOption}
                              addressOptionName={addressOptionName}
                            />
                          ) : (uniqueOption.half_width_number_flg || 0) === 1 ? (
                            <InputFreeTextHalfWidthNumber
                              addData={addData}
                              setAddData={setAddData}
                              uniqueOption={uniqueOption}
                              addressOptionName={addressOptionName}
                            />
                          ) : (
                            <InputFreeText
                              addData={addData}
                              setAddData={setAddData}
                              uniqueOption={uniqueOption}
                              addressOptionName={addressOptionName}
                            />
                          )
                        ) : uniqueOption.option_type === 1 ? (
                          <>
                            <PoSelect
                              key={"tableColumnKomokuDataSelect" + option_i}
                              value={
                                addData.customerInfo[
                                  uniqueOption.option_name as string
                                ]
                              }
                              onChange={(e) => {
                                let customerInfo = addData.customerInfo;
                                customerInfo[
                                  uniqueOption.option_name as string
                                ] = e.target.value as string;
                                setAddData((addData) => ({
                                  ...addData,
                                  customerInfo,
                                }));
                              }}
                              fullWidth
                            >
                              {option_selects.map(
                                (option_select: string, select_i) => {
                                  return (
                                    <MenuItem
                                      key={
                                        "tableColumnKomokuMenuItem" +
                                        option_i +
                                        "_" +
                                        select_i
                                      }
                                      value={option_select}
                                      sx={{
                                        fontSize: "14px",
                                        height:
                                          option_select === ""
                                            ? "14px"
                                            : "24px",
                                        minHeight: "auto",
                                      }}
                                    >
                                      {option_select}
                                    </MenuItem>
                                  );
                                },
                              )}
                            </PoSelect>
                            {uniqueOption.option_comment !== "" ? (
                              <PoHelper>{uniqueOption.option_comment}</PoHelper>
                            ) : null}
                          </>
                        ) : uniqueOption.option_type === 2 ? (
                          <>
                            <PoCheckGroup>
                              {option_selects.map(
                                (option_select: string, select_i) => {
                                  const customerInfoList =
                                    addData.customerInfo[
                                      uniqueOption.option_name as string
                                    ] as string[];
                                  return (
                                    <PoCheckRow
                                      key={
                                        "tableColumnKomokuDataBox" +
                                        option_i +
                                        "_" +
                                        select_i
                                      }
                                    >
                                      <PoCheckbox
                                        checked={
                                          customerInfoList.findIndex(
                                            (_option_select) =>
                                              _option_select === option_select,
                                          ) > -1
                                        }
                                        onClick={() => {
                                          let _customerInfoList =
                                            customerInfoList.concat();
                                          if (
                                            customerInfoList.findIndex(
                                              (_option_select) =>
                                                _option_select === option_select,
                                            ) > -1
                                          ) {
                                            _customerInfoList =
                                              _customerInfoList.filter(
                                                (_option_select) =>
                                                  _option_select !==
                                                  option_select,
                                              );
                                          } else {
                                            _customerInfoList.push(option_select);
                                          }
                                          let customerInfo = addData.customerInfo;
                                          customerInfo[
                                            uniqueOption.option_name as string
                                          ] = _customerInfoList;
                                          setAddData((addData) => ({
                                            ...addData,
                                            customerInfo,
                                          }));
                                        }}
                                      />
                                      {option_select}
                                    </PoCheckRow>
                                  );
                                },
                              )}
                            </PoCheckGroup>
                            {uniqueOption.option_comment !== "" ? (
                              <PoHelper>{uniqueOption.option_comment}</PoHelper>
                            ) : null}
                          </>
                        ) : uniqueOption.option_type === 3 ? (
                          <>
                            <PoTextField
                              id="textFieldIdDate"
                              fullWidth
                              type="date"
                              value={
                                addData.customerInfo[
                                  uniqueOption.option_name as string
                                ]
                              }
                              onChange={async (e) => {
                                let customerInfo = addData.customerInfo;
                                customerInfo[
                                  uniqueOption.option_name as string
                                ] = e.target.value;
                                setAddData((addData) => ({
                                  ...addData,
                                  customerInfo,
                                }));
                              }}
                            />
                            {uniqueOption.option_comment !== "" ? (
                              <PoHelper>{uniqueOption.option_comment}</PoHelper>
                            ) : null}
                          </>
                        ) : uniqueOption.option_type === 4 ? (
                          <>
                            <PoFileDrop
                              inputProps={{
                                id: "textFieldPicture",
                                onChange: (
                                  event_file: React.ChangeEvent<HTMLInputElement>,
                                ) => {
                                  if (
                                    event_file.target.files &&
                                    event_file.target.files.length > 0
                                  ) {
                                    const file = event_file.target.files[0];
                                    const updatedPostPictures = {
                                      ...postPictures,
                                      [uniqueOption.option_name as string]: file,
                                    };
                                    setPostPicture(updatedPostPictures);
                                  }
                                },
                              }}
                              error={postPicturesError[uniqueOption.option_name as string]}
                              onClear={() => {
                                const updated = { ...postPictures };
                                delete updated[uniqueOption.option_name as string];
                                setPostPicture(updated);
                                setPostPicturesError({ ...postPicturesError, [uniqueOption.option_name as string]: "" });
                              }}
                            />
                            {uniqueOption.option_comment !== "" ? (
                              <PoHelper>{uniqueOption.option_comment}</PoHelper>
                            ) : null}
                          </>
                        ) : null}
                      </PoField>
                    );
                  }
                })}
              </Box>
            </Paper>
          </Typography>
        ) : null}
      </PoModalShell>
      <LeaveGuard
          open={leaveGuardOpen}
          fieldName=""
          title="担当アカウントの変更"
          message="担当アカウントを変更すると、入力内容がリセットされます。"
          onClose={() => {
            setLeaveGuardOpen(false);
            setAddData((prev) => ({ ...prev, addStatus: "change_account" }));
          }}
          onReturn={() => setLeaveGuardOpen(false)}
        />
    </>
  ) : null;
}
